module.exports = ".uppdateMindMapIcon{\n    width: 25px;\n    height: 25px;\n    position: absolute;\n    top: 0;\n    right: 0;\n    background-color: gainsboro;\n    border-radius: 50%;\n    text-align: center;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    cursor: pointer;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/bookShared/popups/mindmap/mindmap.component.css
// module id = ./src/app/bookShared/popups/mindmap/mindmap.component.css
// module chunks = main